import {
    applyMiddleware,
    combineReducers,
    compose,
    createStore,
    Reducer,
} from 'redux';
import createSagaMiddleware from 'redux-saga';

import { AgencyReducers } from '../modules/Agency/store/reducers';
import { ApplyPositionReducer, CareersReducer } from '../modules/Careers/store/reducers';
import { ContactReducers } from '../modules/Contacts/store/reducers';
import { HomeReducers } from '../modules/Home/store/reducers';
import { LayoutReducers } from '../modules/Layout/store/reducers';
import { LoginReducer } from '../modules/Login/store/reducers';
import { ProjectsReducers } from '../modules/Projects/store/reducers';
import rootSaga from '../sagas';
import { IApplicationState } from './models';

const rootReducer: Reducer<IApplicationState> = combineReducers({
    agency: AgencyReducers,
    careers: combineReducers({
        vacancies: CareersReducer,
        apply: ApplyPositionReducer,
    }),
    layout: LayoutReducers,
    home: HomeReducers,
    projects: ProjectsReducers,
    contact: ContactReducers,
    login: LoginReducer
});

// tslint:disable-next-line:typedef
export default function configureStore () {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const composeEnhancers =
        typeof window === 'object' &&
            (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            }) : compose;
    const store = createStore(rootReducer, undefined, composeEnhancers(middlewareEnhancer));
    sagaMiddleware.run(rootSaga);

    return store;
}
